import { Link } from "react-router-dom";
import { categories, comics } from "@/mocks/comics";

export default function Footer() {
  const hotComics = comics.slice(0, 6);

  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="mx-auto w-full px-4 py-12 md:px-6 lg:px-10 lg:py-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          {/* Brand */}
          <div className="flex flex-col gap-4">
            <Link to="/" className="flex items-center gap-2" aria-label="178漫画网 首页">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-fire-fill text-lg" aria-hidden="true" />
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">
                178<span className="text-primary-500">漫画</span>网
              </span>
            </Link>
            <p className="text-sm leading-6 text-foreground-700">
              178漫画网提供《家庭教师》等热门漫画的在线免费阅读，下拉式阅读方式流畅便捷，海量漫画随心看。
            </p>
            <div className="flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-md bg-background-200 text-foreground-700 transition-colors hover:text-primary-600">
                <i className="ri-wechat-line" aria-hidden="true" />
              </span>
              <span className="flex h-8 w-8 items-center justify-center rounded-md bg-background-200 text-foreground-700 transition-colors hover:text-primary-600">
                <i className="ri-weibo-line" aria-hidden="true" />
              </span>
              <span className="flex h-8 w-8 items-center justify-center rounded-md bg-background-200 text-foreground-700 transition-colors hover:text-primary-600">
                <i className="ri-qq-line" aria-hidden="true" />
              </span>
              <span className="flex h-8 w-8 items-center justify-center rounded-md bg-background-200 text-foreground-700 transition-colors hover:text-primary-600">
                <i className="ri-mail-line" aria-hidden="true" />
              </span>
            </div>
          </div>

          {/* Quick links */}
          <nav aria-label="快速导航">
            <h3 className="mb-4 text-sm font-bold text-foreground-950">快速导航</h3>
            <ul className="flex flex-col gap-2.5 text-sm text-foreground-700">
              <li>
                <Link to="/" className="transition-colors hover:text-primary-600">网站首页</Link>
              </li>
              <li>
                <Link to="/category/all" className="transition-colors hover:text-primary-600">全部漫画</Link>
              </li>
              <li>
                <Link to="/category/all?sort=hot" className="transition-colors hover:text-primary-600">人气排行榜</Link>
              </li>
              <li>
                <Link to="/manga/jiating-jiaoshi" className="transition-colors hover:text-primary-600">家庭教师专区</Link>
              </li>
              <li>
                <Link to="/about" className="transition-colors hover:text-primary-600">关于我们</Link>
              </li>
            </ul>
          </nav>

          {/* Categories */}
          <nav aria-label="漫画分类">
            <h3 className="mb-4 text-sm font-bold text-foreground-950">漫画分类</h3>
            <ul className="flex flex-wrap gap-x-4 gap-y-2.5 text-sm text-foreground-700">
              {categories.map((c) => (
                <li key={c.slug}>
                  <Link to={`/category/${c.slug}`} className="whitespace-nowrap transition-colors hover:text-primary-600">
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          {/* Hot comics */}
          <nav aria-label="热门漫画">
            <h3 className="mb-4 text-sm font-bold text-foreground-950">热门漫画</h3>
            <ul className="flex flex-col gap-2.5 text-sm text-foreground-700">
              {hotComics.map((c) => (
                <li key={c.id}>
                  <Link to={`/manga/${c.id}`} className="truncate transition-colors hover:text-primary-600">
                    {c.title}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        </div>

        <div className="mt-10 flex flex-col items-center gap-3 border-t border-background-200 pt-6 sm:flex-row sm:justify-between">
          <p className="text-xs text-foreground-600">
            © 2026 178漫画网 178mh.com 版权所有 | 本站所有漫画内容仅供学习交流使用
          </p>
          <div className="flex flex-wrap items-center gap-4 text-xs text-foreground-600">
            <Link to="/about" className="transition-colors hover:text-primary-600">联系我们</Link>
            <span className="hidden sm:inline">·</span>
            <Link to="/about" className="transition-colors hover:text-primary-600">免责声明</Link>
            <span className="hidden sm:inline">·</span>
            <span>不良信息举报</span>
          </div>
        </div>
      </div>
    </footer>
  );
}